import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getSharedMap } from '../api/client';
import NestedEggCanvas from './ListView/NestedEggCanvas';

export default function ShareView() {
  const { token } = useParams();
  const [map, setMap] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const data = await getSharedMap(token);
        setMap(data);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [token]);

  function formatDate(d) {
    if (!d) return '';
    return new Date(d).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center">
        <span className="text-txt-secondary text-sm">Loading...</span>
      </div>
    );
  }

  if (error || !map) {
    return (
      <div className="min-h-screen bg-canvas flex flex-col items-center justify-center px-6">
        <img src="/bcd-icon.png" alt="" className="w-12 opacity-20 mb-4" />
        <p className="text-txt-secondary">This map is no longer available.</p>
      </div>
    );
  }

  return (
    <div className="h-screen bg-canvas flex flex-col overflow-hidden">
      {/* Branded bar */}
      <div className="bg-navy px-6 py-2.5 flex items-center justify-between flex-shrink-0 border-b-[3px] border-gold">
        <div className="flex items-center gap-2">
          <img src="/bcd-icon.png" alt="BCD" className="h-5 w-auto" />
          <span className="text-white font-heading font-bold text-sm uppercase tracking-wide">
            The Clarity Map
          </span>
        </div>
        <div className="flex items-center gap-2 text-white/70 text-xs">
          <span className="font-semibold">{map.name}</span>
          <span>·</span>
          <span>{map.clientName}{map.updatedAt ? ` · ${formatDate(map.updatedAt)}` : ''}</span>
        </div>
      </div>

      {/* Nested egg canvas (includes measurement bar) */}
      <NestedEggCanvas tiles={map.tiles} mapName={map.name} measurement={map.measurement} />

      {/* Footer */}
      <div className="flex-shrink-0 px-6 py-2 border-t border-black/15 flex items-center justify-between bg-white">
        <div className="flex items-center gap-1.5">
          <img src="/bcd-icon.png" alt="" className="h-3.5 w-auto opacity-50" />
          <span className="text-[10px] text-txt-secondary uppercase tracking-wider">
            The Clarity Map · Brain-Centric Design
          </span>
        </div>
        <span className="text-[10px] text-txt-secondary uppercase tracking-wider">
          {map.clientName}{map.updatedAt ? ` · ${formatDate(map.updatedAt)}` : ''}
        </span>
      </div>
    </div>
  );
}
